import React from 'react';
import clsx from 'clsx';
import { makeStyles, Theme } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {
  COLOR_BLUE,
  COLOR_DARK_GRAY,
  COLOR_LIGHT_GRAY,
  COLOR_TEXT,
} from '../styles/colors';
import { FONT_PROXIMA_NOVA } from '../styles/fonts';

interface InputProps {
  className?: string;
  inputFieldClassName?: string;
  labelClassName?: string;
  labelShrinkClassName?: string;
  type?: 'text' | 'password' | 'number';
  label?: string;
  value: string;
  error?: string;
  min?: number;
  max?: number;
  fontSize?: number;
  autoFocus?: boolean;
  multiLine?: boolean;
  disabled?: boolean;
  rows?: number;
  onChange?: (value:string, event:any) => void;
  onBlur?: () => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  input: {
    borderRadius: 0,
    backgroundColor: COLOR_LIGHT_GRAY,

    '&:before': {
      borderWidth: '2px',
      borderColor: COLOR_DARK_GRAY,
    },
    '&:after': {
      borderWidth: '2px',
      borderColor: COLOR_BLUE,
    },

    '&:hover': {
      backgroundColor: COLOR_LIGHT_GRAY,

      '&:before': {
        borderWidth: '2px',
      },
    }
  },

  inputLabel: {
    top: (props:InputProps) => theme.typography.pxToRem(-1 * (16 - (props.fontSize || 16))),
    left: theme.spacing(0.5),
    fontFamily: FONT_PROXIMA_NOVA,
    fontSize: (props:InputProps) => theme.typography.pxToRem(props.fontSize || 16),
    lineHeight: 1,
    color: COLOR_TEXT,

    '&$inputLabelFocused': {
      color: COLOR_BLUE,
      fontWeight: 600,
    }
  },
  inputLabelShrink: {
    fontWeight: 600,
    fontSize: (props:InputProps) => theme.typography.pxToRem((props.fontSize || 16) * 0.8),
    color: COLOR_BLUE,
  },
  inputLabelFocused: {},

  inputField: {
    padding: theme.spacing(3, 2, 1),
    fontFamily: FONT_PROXIMA_NOVA,
    fontSize: (props:InputProps) => theme.typography.pxToRem(props.fontSize || 16),
    lineHeight: 1,
    color: COLOR_TEXT,
  },
}), { name: Input.name });

export default function Input (props: InputProps) {
  const {
    className,
    inputFieldClassName,
    labelClassName,
    labelShrinkClassName,
    type = 'text',
    label,
    value,
    error,
    min,
    max,
    autoFocus = false,
    multiLine = false,
    disabled = false,
    rows = 5,
    onChange = (value:string, event:any) => {},
    onBlur = () => {},
  } = props;
  const classes = useStyles(props);

  return (
    <TextField
      className={className}
      InputProps={{
        classes: {
          root: classes.input,
          input: clsx(classes.inputField, inputFieldClassName),
        },
      }}
      InputLabelProps={{
        className: clsx(classes.inputLabel, labelClassName),
        classes: {
          shrink: clsx(classes.inputLabelShrink, labelShrinkClassName),
          focused: classes.inputLabelFocused,
        },
      }}
      inputProps={{ min, max }}
      type={type}
      label={label}
      variant='filled'
      error={!!error}
      helperText={error}
      value={value}
      autoFocus={autoFocus}
      multiline={multiLine}
      rows={rows}
      disabled={disabled}
      onChange={(event:any) => onChange(event.target.value, event)}
      onBlur={onBlur}
    />
  );
}
